import React, { useEffect, useState } from 'react';
function getInitialTarget(): number {
  // Persist a target 23h59m from first visit so the countdown feels real across reloads.
  const KEY = 'kit_offer_deadline';
  const stored = typeof window !== 'undefined' ? window.localStorage.getItem(KEY) : null;
  if (stored) {
    const parsed = parseInt(stored, 10);
    if (!Number.isNaN(parsed) && parsed > Date.now()) return parsed;
  }
  const target = Date.now() + (23 * 60 * 60 + 59 * 60) * 1000;
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(KEY, String(target));
  }
  return target;
}
function pad(n: number): string {
  return n.toString().padStart(2, '0');
}
export function CountdownTimer() {
  const [target] = useState<number>(getInitialTarget);
  const [remaining, setRemaining] = useState<number>(() => Math.max(0, target - Date.now()));
  useEffect(() => {
    const id = setInterval(() => {
      setRemaining(Math.max(0, target - Date.now()));
    }, 1000);
    return () => clearInterval(id);
  }, [target]);
  const totalSeconds = Math.floor(remaining / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  const Box = ({
    value,
    label
  }: {
    value: string;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-2">
      <span className="bg-white text-red-600 font-mono font-bold text-base md:text-lg px-2 py-0.5 rounded min-w-[2.2rem] text-center tabular-nums" data-id="element-3">
        {value}
      </span>
      <span className="text-[10px] uppercase tracking-wide mt-0.5 text-white/90" data-id="element-4">
        {label}
      </span>
    </div>;
  return <div className="flex items-end gap-1.5" role="timer" aria-label="Tiempo restante de la oferta" data-id="element-5">
      <Box value={pad(hours)} label="Horas" data-id="element-6" />
      <span className="text-white font-bold pb-3" data-id="element-7">:</span>
      <Box value={pad(minutes)} label="Min" data-id="element-8" />
      <span className="text-white font-bold pb-3" data-id="element-9">:</span>
      <Box value={pad(seconds)} label="Seg" data-id="element-10" />
    </div>;
}